import React from "react";
import { Dropdown, Icon } from "antd";
import shortid from "shortid";

const Subtitle = props => {
  const { data } = props;
  return (
    <Dropdown
      overlay={
        <ul className='subtitle'>
          {data.map(item => {
            return (
              <li className='subtitle__item' key={shortid.generate()}>
                <Icon type={item.icon} /> {item.description}
              </li>
            );
          })}
        </ul>
      }
    >
      <Icon type='question-circle' style={{ fontSize: "1rem" }} />
    </Dropdown>
  );
};

export default Subtitle;
